import type { CreateBlockPayloadInput } from '@domain/schemas/payload.schema';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { CreateBlockResponse } from '@responses/blocks';
import axios from 'axios';

import { queryClient } from '../utils/queryClient';

export const createBlock = async (data: CreateBlockPayloadInput): Promise<CreateBlockResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'post',
    url: 'blocks',
    data,
  });

  const response = await axios(networkPayload);
  await queryClient.invalidateQueries({ queryKey: ['search'] });
  return response.data;
};
